import { createSlice } from '@reduxjs/toolkit'
import { strapiFetch, StrapiApiError } from '../../api/strapi'

const slice = createSlice({
    name: 'team',
    initialState: {
        data: null,
        loading: false,
        loaded: false,
        error: null,
    },
    reducers: {
        setLoading: (state, action) => { state.loading = action.payload },
        setLoaded: (state, action) => { state.loaded = action.payload },
        setData: (state, action) => { state.data = action.payload },
        setError: (state, action) => { state.error = action.payload },
    },
})

export default slice.reducer

const { setLoading, setLoaded, setData, setError } = slice.actions

export const loadTeamData = (locale) => async dispatch => {
    dispatch(setLoading(true))
    dispatch(setError(null))
    try {
        // `populate=*` only reaches one level deep, but divisions->members->photo is
        // nested two components deep, so it needs an explicit populate path here.
        const json = await strapiFetch('/api/team-page', {
            locale,
            params: {
                'populate[seo]': 'true',
                'populate[banner][populate][bannerImage]': 'true',
                'populate[divisions][populate][members][populate][photo]': 'true',
                'populate[companyIntro][populate][image]': 'true',
                'populate[companyIntro][populate][button]': 'true',
            },
        })
        dispatch(setData(json.data))
        dispatch(setLoaded(true))
    } catch (e) {
        dispatch(setError(e instanceof StrapiApiError ? e.message : 'Failed to load team page'))
    } finally {
        dispatch(setLoading(false))
    }
}
